import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SeveritySelected } from 'src/app/helpers';
import { editableRole } from 'src/app/helpers/enums/role-type.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { InformationService } from 'src/app/services/information/information.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {
  public siteUrl: string = environment().dms;
  public role: string = null;

  public saving: boolean = false;
  public saved: boolean = false;

  public title: string = null;
  public ratingScore: string | number = null;
  public gradeCV: string | number = null;
  public gradePV: string | number = null;
  public rating: Object = {};
  public ratingSubmitOn: boolean = false;
  public dropzoneOn: boolean = false;

  public selectedSeverity: SeveritySelected = {
    exterior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null
      },
      endCorrection: {}
    },
    interior: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null
      },
      endCorrection: {}
    },
    mechanics: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null
      },
      endCorrection: {}
    },
    frame: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null
      },
      endCorrection: {}
    },
    major_options: {
      state: [],
      overall: {
        rating: null,
        labour_cost: null,
        part_cost: null,
        repair_cost: null
      },
      endCorrection: {}
    }
  };
  public overAllObj: Object = {};
  public extOverall: number = null;
  public intOverall: number = null;
  public frameOverall: number = null;
  public mecOverall: number = null;
  public majorOptOverall: number = null;

  public extOverallCost: number = null;
  public intOverallCost: number = null;
  public frameOverallCost: number = null;
  public mecOverallCost: number = null;
  public majorOptOverallCost: number = null;

  public vinInfo: Object = {};

  public subscriptions: Subscription[] = [];
  public disableForm: boolean = false;

  public modalRef: BsModalRef = null;
  @ViewChild(ModalDirective, { static: false }) confirm: ModalDirective;
  public editableRole: string[] = editableRole;
  public ratingCount = new Array(16);
  public repairForm: UntypedFormGroup = this._fb.group({
    repair_panels: ['', [Validators.required]]
  });

  constructor(
    public router: Router,
    public location: Location,
    public modal: BsModalService,
    public ratingService: RatingService,
    public sharedService: SharedService,
    public authService: AuthService,
    public toastr: ToastrService,
    public cdr: ChangeDetectorRef,
    public estimateService: EstimatesService,
    public informationService: InformationService,
    private _fb: UntypedFormBuilder,
    public userService: UserService
  ) {
    this.authUser();
    this.getVinInfo();

    // Resetting the canDeactivate gaurd
    this.ratingService.ratingSaved.next(false);
  }

  get formData() {
    return this.repairForm.controls;
  }

  ngOnInit(): void {
    this.cdr.detectChanges();
    this.sharedService.title.subscribe((res) => {
      this.title = res;
    });

    this.sharedService.severity.subscribe((res) => {
      if (res) {
        this.rating = res;
        this.ratingScore = this.rating[this.title.toLowerCase().replace(/\s/g, '_')]
          ? this.rating[this.title.toLowerCase().replace(/\s/g, '_')]['overall']['rating']
          : 'N/A';
        this.ratingScore = +this.ratingScore;
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('grading') || event.url.includes('repair-cost')) {
          this.exteriorHide();
          setTimeout(() => {
            this.getState();
          }, 0);
          this.ratingSubmitOn = true;
        } else {
          this.ratingSubmitOn = false;
        }

        if (event.url.includes('repair-cost') && !event.url.includes('grading')) {
          this.dropzoneOn = true;
          if (this.role !== 'evaluator') {
            this.getDocs();
          }
        } else {
          this.dropzoneOn = false;
        }
      }
    });
    this.navigationCheck();
    this.getVehicleInfo();

    // START => getting report status of a vehicle from API and set it to localStorage
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
      const vehicleStatus = Object.values(res['data']);

      // this.disableForm = res['data']['gallery'];
      // vehicleStatus.every((status: boolean) => status === true)
      localStorage.setItem('vehicleStatus', `${this.disableForm}`);
    });
    this.getVehicleData();
    // END
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  authUser() {
    const authSub = this.authService.user.subscribe((res) => {
      if (res) {
        let details: Object =
          res['user'] && res['user']['user_data'] ? res['user']['user_data'] : null;

        this.role = details['role'] || 'admin';
      }
    });

    this.subscriptions.push(authSub);
  }

  navigationCheck() {
    if (this.router.url.includes('grading') || this.router.url.includes('repair-cost')) {
      this.exteriorHide();
      this.ratingSubmitOn = true;
    } else {
      this.ratingSubmitOn = false;
    }

    if (this.router.url.includes('repair-cost') && !this.router.url.includes('grading')) {
      this.dropzoneOn = true;

      if (this.role !== 'evaluator') {
        this.getDocs();
      }
    } else {
      this.dropzoneOn = false;
    }
  }

  getVinInfo() {
    const infoSub = this.sharedService.vinInformation.subscribe((res) => {
      if (res) {
        this.vinInfo = res;
      }
    });
    this.subscriptions.push(infoSub);
  }

  overAllCheck: boolean = false;
  // Getting state data
  getState() {
    let data: object = { vehicle_id: this.sharedService.getVehicleId };

    const stateSub = this.ratingService.getRatingStates(data).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object = res['data'];

          if (success && Object.keys(data).length) {
            const states: SeveritySelected = data['ratingStates']
              ? JSON.parse(data['ratingStates']['rating_states'])
              : null;
            // let interiorEC: object = states ? states.interior.endCorrection : {};
            // let frameEC: object = states ? states.frame.endCorrection : {};

            this.selectedSeverity = states;

            this.overAllObj = res;
            this.overAllCheck =
              this.overAllObj &&
              Object.keys(this.overAllObj).length &&
              typeof this.overAllObj === 'object';
            this.ratingService.overallChecker.next(this.overAllCheck);

            if (this.overAllCheck) {
              this.extOverall = +(states ? states['exterior']['overall']['rating'] ?? 5 : 5);
              this.intOverall = +(states ? states['interior']['overall']['rating'] ?? 5 : 5);
              this.mecOverall = +(states ? states['mechanics']['overall']['rating'] ?? 5 : 5);
              this.frameOverall = +(states ? states['frame']['overall']['rating'] ?? 5 : 5);
              this.majorOptOverall = +(states
                ? states['major_options']['overall']['rating'] ?? 5
                : 5);

              this.extOverallCost = +(states
                ? states['exterior']['overall']['repair_cost'] ?? 0
                : 0);
              this.intOverallCost = +(states
                ? states['interior']['overall']['repair_cost'] ?? 0
                : 0);
              this.mecOverallCost = +(states
                ? states['mechanics']['overall']['repair_cost'] ?? 0
                : 0);
              this.frameOverallCost = +(states
                ? states['frame']['overall']['repair_cost'] ?? 0
                : 0);
              this.majorOptOverallCost = +(states
                ? states['major_options']['overall']['repair_cost'] ?? 0
                : 0);

              this.gradeCV =
                this.extOverall * 0.5 +
                this.intOverall * 0.1 +
                this.mecOverall * 0.3 +
                this.frameOverall * 0.05 +
                this.majorOptOverall * 0.05;

              this.endCorrection(this.gradeCV);
            }
          }
        }
      },
      (error: HttpErrorResponse) => {}
    );

    this.subscriptions.push(stateSub);
  }

  endCorrection(grade: number) {
    this.gradePV = null;

    let milage: object = this.vinInfo && this.vinInfo['odo'] ? this.vinInfo['odo'] : null;
    //

    if (grade >= 4 && milage['value'] > 100000) {
      this.gradePV = 3.9;
    }

    if (this.selectedSeverity) {
      let interior: Object = this.selectedSeverity.interior.endCorrection;
      let frame: Object = this.selectedSeverity.frame.endCorrection;
      let mechanics: Object = this.selectedSeverity.mechanics.endCorrection;

      if (Object.keys(interior).length && interior) {
        let airBagSeverityLvl: number | string = interior['air_bag'].severity_level;

        if (grade >= 3.4) {
          if (+airBagSeverityLvl === 1) {
            this.gradePV = 3.4;
          }
        }
      }

      if (Object.keys(mechanics).length && mechanics) {
        for (let prop in mechanics) {
          if (grade >= 4) {
            let severityLvl: number | string = mechanics[prop].severity_level;

            if (+severityLvl < 3) {
              this.gradePV = 3.9;
            }
          }
        }
      }

      if (Object.keys(frame).length && frame) {
        for (let prop in frame) {
          if (grade >= 2.4) {
            let severityLvl: number | string = frame[prop].severity_level;

            if (+severityLvl < 3) {
              this.gradePV = 2.4;
            }
          }
        }
      }
    }

    this.gradePV = +(+this.gradePV).toFixed(1);
  }

  // Document upload and get
  documentLoaded: boolean = false;
  bodyShopUploading: boolean = false;
  workShopUploading: boolean = false;
  bodyShopfiles: File[] = [];
  workShopfiles: File[] = [];
  bodyShopDoc: object[] = [];
  workShopDoc: object[] = [];
  format: string = 'application/pdf';
  uploadPDF(ev: NgxDropzoneChangeEvent, order: number) {
    switch (order) {
      case 1:
        this.bodyShopfiles.push(...ev.addedFiles);

        if (this.bodyShopfiles.length > 1) {
          this.bodyShopfiles.splice(0, 1);
        }
        break;
      case 2:
        this.workShopfiles.push(...ev.addedFiles);

        if (this.workShopfiles.length > 1) {
          this.workShopfiles.splice(0, 1);
        }
        break;
    }
  }

  removePDF(file: File, order: number) {
    switch (order) {
      case 1:
        this.bodyShopfiles.splice(this.bodyShopfiles.indexOf(file), 1);
        break;
      case 2:
        this.workShopfiles.splice(this.workShopfiles.indexOf(file), 1);
        break;
    }
  }

  uploadDocs(file: File, type: string) {
    const FD: FormData = new FormData();
    FD.set('vehicle_id', this.sharedService.getVehicleId);
    FD.set('type', type);
    FD.set('document', file);

    if (type === '1') this.bodyShopUploading = true;
    else this.workShopUploading = true;

    this.ratingService.saveDocument(FD).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let message: string = res['data'];

          if (success) {
            //
            this.bodyShopUploading = false;
            this.workShopUploading = false;
            this.toastr.success('Document added successfully', 'Success');
            this.getDocs();
          } else {
            this.bodyShopUploading = false;
            this.workShopUploading = false;
            this.toastr.error(message, 'Failed');
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.bodyShopUploading = false;
        this.workShopUploading = false;
        this.toastr.error('Something went wrong', 'Failed');
      }
    );
  }

  getDocs() {
    const data: object = {
      vehicle_id: this.sharedService.getVehicleId
    };

    this.documentLoaded = true;
    this.ratingService.getDocument(data).subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object[] = res['data'];

          if (success) {
            this.documentLoaded = false;
            this.bodyShopDoc = data.filter((document: object) => document['type'] === '1');
            this.workShopDoc = data.filter((document: object) => document['type'] === '2');
            //
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.documentLoaded = false;
      }
    );
  }

  deleteDocs(docId: string, type: string) {
    const data: object = {
      document_id: docId
    };

    this.ratingService.deleteDocument(data).subscribe(
      (res) => {
        let success: boolean = res['success'];
        let message: string = res['data'];

        if (success) {
          this.toastr.success(message, 'Success');

          if (type === '1') this.bodyShopfiles = [];
          else this.workShopfiles = [];

          this.getDocs();
          //
        }
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Something went wrong', 'Failed');
      }
    );
  }

  saveData() {
    let repairCostTotal: number =
      this.extOverallCost +
      this.intOverallCost +
      this.mecOverallCost +
      this.frameOverallCost +
      this.majorOptOverallCost;

    const ratingOverall: Object = {
      vehicle_id: this.sharedService.getVehicleId,
      overall_exterior: this.extOverall.toString(),
      overall_interior: this.intOverall.toString(),
      overall_mechanics: this.mecOverall.toString(),
      overall_frame: this.frameOverall.toString(),
      overall_major_options: this.majorOptOverall.toString(),
      calculated_value: this.gradeCV.toString(),
      perceived_value: (this.gradePV || 0).toString(),
      overall_repair_cost: repairCostTotal.toString()
    };

    if (ratingOverall) {
      this.saving = true;
      this.ratingService.setRatingOverall(ratingOverall).subscribe(
        (res) => {
          let success: boolean = res['success'];
          let data: any = res['data'];

          if (success) {
            this.saving = false;
            this.saved = true;
            this.ratingService.ratingSaved.next(true);
            this.toastr.success('Ratings submitted successfully', 'Success');
          } else {
            this.saving = false;
            this.toastr.error(data, 'Failed');
          }
          //
        },
        (error) => {
          this.saving = false;
          this.toastr.success('Something went wrong', 'Failed');
        }
      );
    } else {
      this.ratingService.ratingSaved.next(true);
    }
  }

  exteriorShow() {
    //Showing the overall exterior information in all the components under rating component on click
    let elem = document.querySelector('.overall_exterior_container');

    elem.classList.remove('d-none');
  }

  exteriorHide() {
    let elem = document.querySelector('.overall_exterior_container');

    elem.classList.add('d-none');
  }

  public estimateInfo: Record<string, string | any> = null;
  getVehicleInfo() {
    const formData = {
      vehicle_id: this.sharedService.getVehicleId
    };
    this.estimateService.getEstimateDataAll(formData).subscribe((response) => {
      if (response['success'] && Object.keys(response['data']).length) {
        this.estimateInfo = response['data'];
      }
    });
  }

  getVehicleData() {
    const vehicle_id = { vehicle_id: this.sharedService.getVehicleId };
    this.userService.GetVinInfo(vehicle_id).subscribe(
      (res) => {
        let success = res['success'];
        let data = res['data'];
        if (success && Object.keys(data).length) {
          let vehicleInformation: Object = data['vehicle_details'];
          this.repairForm.get('repair_panels').setValue(vehicleInformation?.['repair_panels']);
        }
      },
      (error) => {}
    );
  }

  savePanelLoad: boolean = false;
  submitted: boolean = false;
  saveRepairData() {
    this.submitted = true;
    if (this.repairForm.invalid) {
      return;
    }
    this.savePanelLoad = true;
    const formData = {
      ...this.repairForm.value,
      vehicle_id: this.sharedService.getVehicleId
    };
    this.informationService.SaveInformation(formData).subscribe(
      (res) => {
        this.savePanelLoad = false;
      },
      (err: HttpErrorResponse) => {
        this.savePanelLoad = false;

        console.log(err);
      }
    );
  }
}
